import type { SVGProps } from 'react';

const TrendUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4568 4.58412L17.7516 4.58456L17.8351 4.59616L17.9175 4.61916L17.9677 4.64046C18.0338 4.66951 18.0956 4.71175 18.15 4.76609L18.1839 4.80279L18.2202 4.84977L18.2653 4.92488L18.2976 5.00014L18.3135 5.05354L18.3249 5.10687L18.3326 5.18538L18.3331 11.4624C18.3331 11.8075 18.0532 12.0874 17.7081 12.0874C17.3916 12.0874 17.1301 11.8522 17.0888 11.5472L17.0831 11.4624L17.0827 6.71662L10.6503 13.1502C10.4284 13.3721 10.0812 13.3923 9.83653 13.2107L9.76642 13.1502L7.29102 10.6749L2.73296 15.233C2.48888 15.477 2.09315 15.477 1.84907 15.233C1.62719 15.0111 1.60701 14.6638 1.78856 14.4192L1.84907 14.3491L6.84907 9.34907C7.07096 9.12719 7.41817 9.10701 7.66285 9.28855L7.73295 9.34906L10.2083 11.8244L16.1977 5.83412H11.4568C11.1404 5.83412 10.8789 5.599 10.8375 5.29393L10.8318 5.20912C10.8318 4.89271 11.0669 4.63121 11.372 4.58983L11.4568 4.58412Z"
      fill="currentColor"
    />
  </svg>
);

export default TrendUpIcon;
